import React from 'react';
import './Loading.css';

/**
 * Компонент загрузки — используется в Suspense fallback и локальных лоадерах.
 * @param {string} text — текст под спиннером (по умолчанию 'Загрузка...')
 * @param {string} className — дополнительный CSS-класс
 */
const Loading = ({ text = 'Загрузка...', className = '' }) => {
    return (
        <div className={`loading-container ${className}`}>
            <div className="loading-spinner"></div>
            {text && <p className="loading-text">{text}</p>}
        </div>
    );
};

export default Loading;